import React, { useState } from 'react';
import { useDraggable } from '@dnd-kit/core';

function getPriorityColor(priority) {
  switch (priority) {
    case 'High':
      return 'rgba(80, 0, 0, 0.65)';
    case 'Medium':
    case 'Low':
    default:
      return 'rgba(0, 0, 0, 0.5)';
  }
}

const Draggable = ({ id, children, ticket, onDoubleClick, onStatusChange, onRightClick, activeTimers, onStartTimer, onStopTimer }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [viewState, setViewState] = useState(0);
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id,
    disabled: false,
  });
  const isDone = ticket.status === 'done';
  const isZohoTicket = ticket.isZohoTicket === true;
  const style = {
    transform: isDragging ?
      `${transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : ''} scale(1.05)` :
      transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    userSelect: 'none',
    opacity: isDragging ? 0.9 : isClicked ? 0.9 : isDone ? 0.5 : 1,
    padding: '2px',
    margin: '0 0 5px 0',
    border: isDragging ? '2px solid #4a9eff' : '1px solid #ccc',
    borderLeft: isZohoTicket ? '4px solid #9B59B6' : (isDragging ? '2px solid #4a9eff' : '1px solid #ccc'),
    borderRadius: '4px',
    fontSize: '12px',
    color: isDone ? '#999' : 'white',
    cursor: isDragging ? 'grabbing' : 'grab',
    backgroundColor: isDone ? '#333' : getPriorityColor(ticket.priority),
    boxShadow: isDragging ? '0 8px 16px rgba(0,0,0,0.3)' : (isZohoTicket ? '0 0 4px rgba(155, 89, 182, 0.3)' : 'none'),
    zIndex: isDragging ? 1000 : 1,
    transition: isDragging ? 'none' : 'all 0.2s ease',
    display: 'flex',
    alignItems: 'stretch',
  };
  const handleMouseDown = () => setIsClicked(true);
  const handleMouseUp = () => setIsClicked(false);
  const handleShiftClick = (event) => {
    if (event.shiftKey) {
      setViewState((prev) => (prev + 1) % 3); // Cycle through 0, 1, 2
    }
  };

  const handleStatusClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (onStatusChange) {
      onStatusChange(ticket._id, isDone ? 'active' : 'done');
    }
  };
  return (
    <div
      ref={setNodeRef}
      data-draggable="true"
      style={style}
      {...listeners}
      {...attributes}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onClick={handleShiftClick}
      onDoubleClick={() => onDoubleClick && onDoubleClick(id)}
      onContextMenu={(e) => onRightClick && onRightClick(e, id)}
    >
      <div style={{ flexGrow: 1, paddingRight: '5px', display: 'flex', flexDirection: 'column' }}>
        {viewState === 1 ? (
          <div style={{ textAlign: 'left' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
              <p style={{ fontSize: '15px', fontWeight: '600', lineHeight: '1.3', margin: 0 }}><strong>{ticket.title}</strong></p>
              {isZohoTicket && (
                <span style={{ backgroundColor: '#9B59B6', color: 'white', padding: '1px 5px', borderRadius: '3px', fontSize: '9px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                  Zoho Desk
                </span>
              )}
            </div>
            {ticket.project && (
              <p style={{ margin: '0 0 8px 0', fontWeight: '500', fontSize: '13px', color: isDone ? '#999' : (ticket.projectRef ? '#4ade80' : '#fff'), lineHeight: '1.3' }}>
                {ticket.project}
              </p>
            )}
            <p style={{ fontSize: '14px', lineHeight: '1.3' }}>{ticket.description}</p>
          </div>
        ) : viewState === 2 ? (
          <div style={{ textAlign: 'left' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
              <p style={{ fontSize: '15px', fontWeight: '600', lineHeight: '1.3', margin: 0 }}><strong>{ticket.title}</strong></p>
              {isZohoTicket && (
                <span style={{ backgroundColor: '#9B59B6', color: 'white', padding: '1px 5px', borderRadius: '3px', fontSize: '9px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                  Zoho Desk
                </span>
              )}
            </div>
            {ticket.project && (
              <p style={{ margin: '0 0 8px 0', fontWeight: '500', fontSize: '13px', color: isDone ? '#999' : (ticket.projectRef ? '#4ade80' : '#fff'), lineHeight: '1.3' }}>
                {ticket.project}
              </p>
            )}
            <p style={{ fontSize: '14px', lineHeight: '1.3' }}>Steps:</p>
            <ul>
              {Array.isArray(ticket.steps) ? (
                ticket.steps.slice().reverse().map((step, index) => (
                  <li key={index}>
                    {step}
                  </li>
                ))
              ) : (
                ticket.steps ? (
                  ticket.steps.split('\n').reverse().map((step, index) => (
                    <li key={index}>{step}</li>
                  ))
                ) : (
                  <li>No steps provided</li>
                )
              )}
            </ul>
          </div>
        ) : (
          children || (
            <div style={{ textAlign: 'left' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                <p style={{ margin: '0 0 2px 0', textAlign: 'left', fontSize: '15px', fontWeight: '600', lineHeight: '1.3' }}><strong>{ticket.title}</strong></p>
                {isZohoTicket && (
                  <span style={{ backgroundColor: '#9B59B6', color: 'white', padding: '1px 5px', borderRadius: '3px', fontSize: '9px', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                    Zoho Desk
                  </span>
                )}
              </div>
              {ticket.project && (
                <p style={{ margin: '0 0 0 0', fontWeight: '500', fontSize: '13px', color: isDone ? '#999' : (ticket.projectRef ? '#4ade80' : '#fff'), textAlign: 'left', lineHeight: '1.3' }}>
                  {ticket.project}
                </p>
              )}
            </div>
          )
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', width: '60px' }}>
        <button
          onClick={handleStatusClick}
          style={{
            flex: 1,
            backgroundColor: isDone ? '#dc3545' : '#28a745',
            color: 'white',
            border: 'none',
            fontSize: '12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            transition: 'all 0.2s ease',
          }}
          title={isDone ? 'Mark as active' : 'Mark as done'}
        >
          {isDone ? '×' : '✓'}
        </button>

        {/* Timer Button */}
        {activeTimers && onStartTimer && onStopTimer && (
          activeTimers.has(ticket._id) ? (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onStopTimer(ticket._id);
              }}
              style={{
                flex: 1,
                backgroundColor: '#bd2130',
                color: 'white',
                border: 'none',
                fontSize: '12px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
              }}
              title="Timer stoppen"
            >
              ⏹
            </button>
          ) : (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onStartTimer(ticket._id, null, null, e.shiftKey);
              }}
              style={{
                flex: 1,
                backgroundColor: '#1e7e34',
                color: 'white',
                border: 'none',
                fontSize: '12px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
              }}
              title="Timer starten"
            >
              ▶
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default Draggable;
